module.exports = __webpack_public_path__ + "static/media/checkins2.b4d96834.svg";